










import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
	components: {}
})
export default class FilterBlock extends Vue {
	@Prop(String)
	protected readonly headline?: string;
}
